// extracted by mini-css-extract-plugin
export default {"container":"search_container__PW-MD","header":"search_header__khz75","body":"search_body__ZV5Rq","footer":"search_footer__4ELpM"};